(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('cookie-consent');
    if (!root || !window.Shopify || !window.Shopify.loadFeatures) return;

    var purposes = ['analytics', 'marketing', 'preferences'];
    var lastFocus = null;

    function privacy() {
      return window.Shopify.customerPrivacy;
    }

    function showView(name) {
      root.querySelectorAll('[data-cookie-consent-view]').forEach(function (view) {
        view.hidden = view.getAttribute('data-cookie-consent-view') !== name;
      });
      var first = root.querySelector('[data-cookie-consent-view="' + name + '"] button, [data-cookie-consent-view="' + name + '"] input');
      if (first) first.focus();
    }

    function syncSwitches() {
      var current = privacy().currentVisitorConsent() || {};
      purposes.forEach(function (purpose) {
        root.querySelector('[data-cookie-consent-purpose="' + purpose + '"]').checked = current[purpose] === 'yes';
      });
    }

    function open(view) {
      lastFocus = document.activeElement;
      root.hidden = false;
      showView(view);
    }

    function close() {
      root.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function record(consent) {
      privacy().setTrackingConsent(consent, function (error) {
        if (error) {
          console.error('[cookie-consent] setTrackingConsent failed', error);
          return;
        }
        close();
      });
    }

    function syncClarity() {
      var id = root.getAttribute('data-clarity-id');
      var cp = privacy();
      if (!id || !cp) return;
      var analytics = cp.analyticsProcessingAllowed();
      if (analytics && !window.clarity) {
        window.clarity = function () {
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
        var tag = document.createElement('script');
        tag.async = true;
        tag.src = 'https://www.clarity.ms/tag/' + id;
        document.head.appendChild(tag);
      }
      if (window.clarity) {
        window.clarity('consentv2', {
          ad_Storage: cp.marketingAllowed() ? 'granted' : 'denied',
          analytics_Storage: analytics ? 'granted' : 'denied'
        });
      }
    }

    function all(value) {
      return { analytics: value, marketing: value, preferences: value };
    }

    function selected() {
      var consent = {};
      purposes.forEach(function (purpose) {
        consent[purpose] = root.querySelector('[data-cookie-consent-purpose="' + purpose + '"]').checked;
      });
      return consent;
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cookie-consent-action]');
      if (!button || !privacy()) return;
      var action = button.getAttribute('data-cookie-consent-action');
      if (action === 'accept') record(all(true));
      if (action === 'reject') record(all(false));
      if (action === 'save') record(selected());
      if (action === 'customize') {
        syncSwitches();
        showView('prefs');
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(
        root.querySelectorAll('button, input, a[href]'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-cookie-consent-open]') || !privacy()) return;
      event.preventDefault();
      syncSwitches();
      open('prefs');
    });

    document.addEventListener('visitorConsentCollected', syncClarity);

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function () {
      if (!privacy()) return;
      syncClarity();
      var current = privacy().currentVisitorConsent() || {};
      var undecided = purposes.every(function (purpose) {
        return !current[purpose];
      });
      // Owner decision 21 Oct 2026: accept all by default instead of asking. Visitors can still change it via [data-cookie-consent-open].
      if (privacy().shouldShowBanner() && undecided) privacy().setTrackingConsent(all(true), function () {});
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
